import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonTitle from '../../../common-components/common-title';

let list = [
    `
      <p class="upgreat-tasks__list-item">Разработать и&nbsp;запустить высокотехнологичную платформу для квалификационных, технических и&nbsp;финальных испытаний программных комплексов участников.</p>
      <p class="upgreat-tasks__list-item">Общие требования к&nbsp;платформе&nbsp;&mdash; высокая отказоустойчивость и&nbsp;принцип open source ключевых сервисов (для обеспечения прозрачности испытаний).</p>
      <p class="upgreat-tasks__bold">Если сам конкурс ПРО//ЧТЕНИЕ&nbsp;&mdash; вызов для профессионалов в&nbsp;BigData и&nbsp;Machine Learning, то&nbsp;реализация его технической части&nbsp;&mdash; вызов для Вебпрактик.</p>
     `,
];

const upgreatTasksPreview = [
    '&mdash;&nbsp;анализировать тексты на&nbsp;русском или английском,',
    '&mdash;&nbsp;находить и&nbsp;выделять смысловые и&nbsp;фактические ошибки в&nbsp;них,',
    '&mdash;&nbsp;давать объяснение (классифицировать ошибки).',
];

const Process = () => {
    return (
        <>
            <div className="upgreat-tasks__preview-wrap">
                <FullWrapper smallPaddings={true} isMargin={false}>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-tasks__preview">
                            <CommonSmallTitle>
                                Командам надо разработать алгоритм, который будет в&nbsp;режиме
                                реального времени
                            </CommonSmallTitle>
                            {upgreatTasksPreview.map(text => (
                                <CommonSmallText key={text} className="upgreat-tasks__paragraph">
                                    {parse(text)}
                                </CommonSmallText>
                            ))}
                            <CommonSmallText className="upgreat-tasks__bold-orange">
                                и&nbsp;делать это в&nbsp;15-20 раз быстрее, чем профессионал!
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </FullWrapper>
            </div>
            <FullWrapper smallPaddings={true} isMargin={false}>
                <CommonSmallText>
                    В&nbsp;случае преодоления технологического барьера, новая технология позволит
                    не&nbsp;просто автоматизировать анализ текстов. &laquo;Роботы&raquo;, обученные
                    по&nbsp;ней, смогут самостоятельно находить причинно-следственные связи
                    в&nbsp;любом массиве информации независимо от&nbsp;темы. А&nbsp;значит,
                    им&nbsp;можно будет делегировать самые разные задачи из&nbsp;любых отраслей.
                    И&nbsp;это кардинально изменит всю мировую экономику.
                </CommonSmallText>
            </FullWrapper>
            <div className="upgreat-tasks__content-wrap">
                <FullWrapper smallPaddings={true} isMargin={false}>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="upgreat-tasks__content">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                                className="upgreat-tasks__content"
                            >
                                <img
                                    className="upgreat-tasks__img"
                                    src="/images/pic/upgreat/upgreat-tasks.png"
                                    alt=""
                                    loading="lazy"
                                />
                                <div>
                                    <CommonTitle>Задача</CommonTitle>
                                    {list.map(item => (
                                        <CommonSmallText key={item}>{parse(item)}</CommonSmallText>
                                    ))}
                                </div>
                            </ScrollAnimation>
                        </div>
                    </ScrollAnimation>
                </FullWrapper>
            </div>
        </>
    );
};

export default Process;
